// extracted by mini-css-extract-plugin
export var emptyState = "_77-d";
export var statCard = "_77-c";
export var table = "_77-0";
export var tableCell = "_77-4";
export var tableCellClickable = "_77-5 _77-4";
export var tableCellDefault = "_77-6 _77-4";
export var tableCellEmpty = "_77-8";
export var tableCellWithValue = "_77-7";
export var tableContainer = "_77-e";
export var tableHeaderWeight = "_77-1";
export var tableHeaderZone = "_77-2";
export var tableRowHeader = "_77-3";
export var viewModeButton = "_77-9";
export var viewModeButtonActive = "_77-a _77-9";
export var viewModeButtonInactive = "_77-b _77-9";